import React from 'react';

import parse from 'html-react-parser';

import { RIGHT_OF_WITHDRAWAL_MODEL } from '../../models/model';
import { Modal } from '@/components/molecules/NewModal';
import { RideGlInformationOutline } from '@rimac-seguros/ride-system-components';

import './styles.scss';

export const ModalRightOfWithdrawal = ({
  isOpen,
  onClose,
}) => {
  const {
    title,
    items,
    tooltip
  } = RIGHT_OF_WITHDRAWAL_MODEL;

  const handleHyper = (e) => {
    e.preventDefault();

    const currentHref = e.currentTarget.href;
    window.open(currentHref, '_blank');
  };

  const formatHtml = (description) => {
    if (!description) return '';

    const options = {
      replace: (domNode) => {
        if (domNode.type === 'tag' && domNode.name === 'a') {
          const href = domNode.attribs.href;

          return (
            <a href={href} onClick={handleHyper}>
              {domNode.children.map((child) => {
                if (child.type === 'text') {
                  return child.data;
                }
                return null;
              })}
            </a>
          );
        }
      },
    };

    return parse(description, options);
  };

  return (
    <Modal
      isOpen={isOpen}
      fullContentOnlyMobile
      onClose={onClose}
      className="col-span-full lg:col-span-8 lg:col-start-3"
      classNameGrid="max-h-dvh overflow-y-auto custom-scroll lg:max-h-auto lg:overflow-y-hidden"
    >
      <div className="modal-rofwd">
        <div className="flex flex-col custom-scroll gap-ride-gl-spacing-2xlarge">
          <div className="modal-rofwd_title">
            <h3>{title}</h3>
          </div>
          <ul>
            {items.map((item, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: item }}  />
            ))}
          </ul>
          <div className="modal-rofwd_tooltip">
            <RideGlInformationOutline size="large" />
            <p dangerouslySetInnerHTML={{ __html: tooltip }} />
          </div>
        </div>
      </div>
    </Modal>
  );
};
